export const responseTypes = [
	{ value: 'message', label: 'Message' },
	{ value: 'flow', label: 'Flow' },
	{ value: 'service', label: 'Service' },
];

export const dialogTypes = [
	{ value: 'intent', label: 'Intent' },
	{ value: 'event', label: 'Event' },
];

export const eventTypes = [
	{
		value: 'chatWidget',
		label: 'Chat Widget',
		options: [
			{ value: 'onLoad', label: 'onLoad' },
			{ value: 'onOpen', label: 'onOpen' },
			{ value: 'onClose', label: 'onClose' },
			{ value: 'onMaximize', label: 'onMaximize' },
			{ value: 'onMinimize', label: 'onMinimize' },
			{ value: 'onIdle', label: 'onIdle' },
			{
				value: 'onTransferToAgent',
				label: 'onTransferToAgent',
			},
		],
	},
	{
		value: 'nlp',
		label: 'NLP',
		options: [{ value: 'onFallback', label: 'onFallback' }],
	},
	{
		value: 'facebook',
		label: 'Facebook',
		options: [{ value: 'onNewUser', label: 'onNewUser' }],
	},
	{
		value: 'twitter',
		label: 'Twitter',
		options: [{ value: 'onNewUser', label: 'onNewUser' }],
	},
	{
		value: 'rest',
		label: 'Rest',
		options: [{ value: 'onNewUser', label: 'onNewUser' }],
	},
	{
		value: 'agent',
		label: 'Agent',
		options: [
			{ value: 'onChatPickupFailure', label: 'onChatPickupFailure' },
			{ value: 'onChatComplete', label: 'onChatComplete' },
			{ value: 'onQueueTimeout', label: 'onQueueTimeout' },
		],
	},
];
